// src/components/common/SeasonalEffects.js
import React, { useEffect, useState } from 'react';
import pb from '../../lib/pocketbase';
import './SeasonalEffects.css';

function SeasonalEffects() {
    const [activeEffect, setActiveEffect] = useState(null);
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        let canceled = false;

        const fetchEffect = async () => {
            try {
                // On cherche l'effet marqué comme actif
                const result = await pb.collection('site_seasonal_effects').getList(1, 1, {
                    filter: 'is_active = true',
                });
                if (!canceled && result.items.length > 0) {
                    setActiveEffect(result.items[0]);
                } else if (!canceled) {
                    setActiveEffect(null);
                }
            } catch (err) {
                // Si la collection n'existe pas encore ou erreur, on ne fait rien
                console.log("Seasonal effects not configured or fetch error:", err);
            }
        };

        fetchEffect();

        // Optionnel: S'abonner aux changements temps réel
        pb.collection('site_seasonal_effects').subscribe('*', function (e) {
            fetchEffect();
        }).catch(() => { }); // Ignorer erreur si la collection n'existe pas

        return () => {
            canceled = true;
            if (pb.realtime.isConnected) {
                pb.collection('site_seasonal_effects').unsubscribe('*').catch(() => { });
            }
        };
    }, []);

    // Générer les particules quand l'effet change
    useEffect(() => {
        if (!activeEffect) {
            setParticles([]);
            return;
        }

        const count = activeEffect.intensity || 50; // Nombre de particules
        const newParticles = [];

        for (let i = 0; i < count; i++) {
            newParticles.push({
                id: i,
                left: Math.random() * 100 + '%',
                animationDuration: (Math.random() * 3 + 2) + 's', // Entre 2 et 5s
                animationDelay: Math.random() * 5 + 's',
                opacity: Math.random(),
                size: (Math.random() * 5 + 2) + 'px'
            });
        }
        setParticles(newParticles);
    }, [activeEffect]);

    if (!activeEffect) return null;

    const renderParticles = () => {
        switch (activeEffect.type) {
            case 'snow':
                return particles.map(p => (
                    <div
                        key={p.id}
                        className="snowflake"
                        style={{
                            left: p.left,
                            width: p.size,
                            height: p.size,
                            animationDuration: p.animationDuration,
                            animationDelay: p.animationDelay,
                            opacity: p.opacity
                        }}
                    />
                ));
            case 'rain':
                return particles.map(p => (
                    <div
                        key={p.id}
                        className="raindrop"
                        style={{
                            left: p.left,
                            animationDuration: (Math.random() * 0.5 + 0.5) + 's', // Plus rapide pour la pluie
                            animationDelay: p.animationDelay,
                        }}
                    />
                ));
            case 'leaves':
                return particles.map(p => (
                    <div
                        key={p.id}
                        className="leaf"
                        style={{
                            left: p.left,
                            animationDuration: (parseFloat(p.animationDuration) + 2) + 's', // Plus lent
                            animationDelay: p.animationDelay,
                            width: p.size * 2, // Plus grand
                            height: p.size * 2,
                            backgroundColor: ['#d35400', '#e67e22', '#c0392b'][Math.floor(Math.random() * 3)]
                        }}
                    />
                ));
            default:
                return null;
        }
    };

    return (
        <div className="seasonal-effects-container">
            {renderParticles()}
        </div>
    );
}

export default SeasonalEffects;
